export default __webpack_public_path__ + "7e9197c844c3fd458feec6d9bcf80431.svg";